export const onThreeSideDocument = (id) => {
  return [18, 33, 28, 31, 32].includes(id);
};
